export default __webpack_public_path__ + "static/media/WHITTIER DISTRIC LOGO_outlined-06.2471f36f.jpg";